// ============================================================
// CONTACT — Numéro WhatsApp & liens externes de l'hôte
// ------------------------------------------------------------
// 🛠️ Un seul endroit à modifier pour changer :
// - le numéro WhatsApp affiché partout sur le site
// - le lien Lodgify de réservation
// - le lien du guide voyageurs
// ============================================================

export const CONTACT = {
  // Numéro WhatsApp au format international (sans + ni espaces)
  whatsappNumber: "262692793155",

  // Message pré-rempli par défaut (URL encodé)
  whatsappDefaultMessage: "Bonjour%2C%20j%27ai%20une%20question%20sur%20le%20Curieux%20Refuge.",

  // Lien direct Lodgify (utilisé en iframe et en lien externe)
  lodgifyUrl: "https://curieuxrefuge.lodgify.com/fr/disponibilites",

  // Lien du petit guide voyageurs (Bitly ou autre)
  guideUrl: "https://bit.ly/CurieuxRefugeGuide",
};

// Helper : construit une URL WhatsApp avec message personnalisé
export const buildWhatsAppUrl = (message) => {
  const text = message ? encodeURIComponent(message) : CONTACT.whatsappDefaultMessage;
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${text}`;
};

export default CONTACT;
